<!--
 * @version: V1.0.0
 * @Date: 2023-10-27 16:50:49
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-27 16:15:25
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\statistics\index.vue
 * @Descripttion:
-->
<template>
  <div :style="{ height: heightStyleObj }">
    <div class="wl-index">
      <div v-loading="Leftloading" class="in-left">
        <div class="ccgl-card">
          <div class="card-head">
            <div class="cell_left">
              <span class="he-title">出库作业统计</span>
            </div>
            <div class="cell_right">
              <span>发货日期：</span>
              <el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" type="daterange" range-separator="-"
                placeholder="选择日期" @change="init">
              </el-date-picker>
            </div>
          </div>
          <!--box_head-->
          <div class="card-body">
            <div class="ddtj-list">
              <!-- 字典映射处理 -->
              <Card v-for="statisticsInfo in dictObj.statisticsData" :key="statisticsInfo.dictCode"
                :order-data="orderData" :statistics-info="statisticsInfo"></Card>
            </div>
          </div>
        </div>
        <!--bl_box_3-->
      </div>
      <!--page_left-->
      <div v-loading="rightLoading" class="in-right">
        <div class="ccgl-card">
          <div class="card-head">
            <div class="he-title">订单状态统计</div>
            <div class="he-czqy">
              <div class="ddzt-lab"><span class="point-1"></span><span class="tit">销售出库单</span></div>
              <div class="ddzt-lab"><span class="point-2"></span><span class="tit">其他出库单</span></div>
            </div>
          </div>
          <!--card-head-->
          <div class="card_body">
            <div id="myChart" :style="{ width: '100%', height: '594px' }"></div>
          </div>
        </div>
      </div>
      <!--page_right-->
    </div>
    <!--logistics_page-->
  </div>
</template>

<script>
import Card from './components/card.vue'
import { getDict } from '@/api/common'
import { getLeftData, getRightData } from '@/api/static'
export default {
  name: 'Statistics',
  components: { Card },
  data() {
    return {
      dictObj: {
        statisticsData: [],
        echartStaticsSaleOrder: [],
        echartStaticsOther: []
      },
      echartsData: {
        otherOrder: [],
        saleOrder: []
      },
      orderData: {
        logisOrderCnt: '',
        printedOrderCnt: '',
        unPrintedOrderCnt: '',
        pickUpCnt: '',
        upPickUpCnt: '',
        getOrderCnt: '',
        signOrderCnt: '',
        unCheckedCnt: '',
        checkedCnt: '',
        freightOrderCnt: ''
      },
      date: [],
      Leftloading: false, // 遮罩
      rightLoading: false // 遮罩
    }
  },
  created() {
    const currentDate = this.parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}');
    const lastMonth = this.parseTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()), '{y}-{m}-{d} {h}:{i}:{s}');
    this.date = [lastMonth, currentDate]
    console.log(this.date);
    this.heightStyleObj = window.innerHeight - 215 + 'px'
    this.getDicts(['echartStaticsSaleOrder', 'statisticsData', 'echartStaticsOther'])
  },
  mounted() {
    this._timeOut = setInterval(() => {
      this.init()
    }, 60000)
    this.init()


  },
  beforeDestroy() {
    clearInterval(this._timeOut)
  },
  methods: {
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      // 代码
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '0%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine: {     //x轴坐标轴，false为隐藏，true为显示
            "show": false,
          },
          axisLabel: { show: false }, //显示x轴的数值
          axisTick: {		//x轴刻度线
            show: false
          },
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'category',
          data: this.dictObj.echartStaticsSaleOrder.map(dict => dict.dictLabel),
          axisTick: {		//y轴刻度线
            show: false
          },
          splitLine: {
            show: false
          },
          // 坐标 轴线
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              show: true,
              fontFamily: '微软雅黑',
              color: "black",
            },
          }
        },
        series: [
          {
            barWidth: '8px',
            type: 'bar',
            data: this.echartsData.saleOrder,
            name: '销售出库单',
            label: {
              show: true,
              position: 'right',
              color: 'black',
              formatter: (params) => {
                return params.data > 0 ? params.data : 0
              }
            },
            barGap: '225%',/*多个并排柱子设置柱子之间的间距*/
            itemStyle: {
              normal: {
                width: '8px',
                color: '#013189',
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius: [4, 4, 4, 4]
              }
            }
          },
          {
            type: 'bar',
            data: this.echartsData.otherOrder,
            name: '其他出库单',
            barWidth: '8px',
            label: {
              show: true,
              position: 'right',
              color: 'black',
              formatter: (params) => {
                return params.data > 0 ? params.data : 0
              }
            },
            itemStyle: {
              normal: {
                color: '#0094ff',
                width: '8px',
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius: [4, 4, 4, 4]
              }
            }
          },
        ]
      })

      this.rightLoading = false;
      // myChart.on('click', params => {
      //   const name = params.name
      //   let self = this
      //   if (name === '物流订单数') {
      //     self.$router.push({ path: '/logistics/logisticsOrderList' })
      //   } else if (name === '已打印拣货单数') {
      //     self.$router.push({ path: '/logistics/logisticsPickingList' })
      //   } else if (name === '已打印到货单数') {
      //     self.$router.push({ path: '/logistics/logisticsArrivalSlipList' })
      //   } else if (name === '已打印快递单数') {
      //     self.$router.push({ path: '/logistics/logisticsExpressBill' })
      //   } else if (name === '已揽件数') {
      //     self.$router.push({
      //       path: '/logistics/logisticsOrderList',
      //       query: { activeName: 'lswldd' }
      //     })
      //   }
      // })
    },
    // async
    init() {
      const that = this;
      // 初始左
      that.rightLoading = true
      that.Leftloading = true
      const [startDate='', endDate=''] = this.date || []

      Promise.all([
        that.getRightData({ startDate, endDate }),
        that.getLeftData({ startDate, endDate })
      ]).then(() => {
        that.$nextTick(() => {
          that.drawLine()
        })
      }).catch(() => {
        that.$message({
          type: 'error',
          message: '请求异常'
        })
        that.Leftloading = false
        that.rightLoading = false
      })
    },
    getRightData(params) {
      return new Promise((resolve, reject) => {

        getRightData(params).then(res => {
          if (res.code === 200) {
            let saleOrder = []
            let otherOrder = []
            if (res.data == null || res.data == '') return resolve()
            // 字典值映射成展示字段
            this.dictObj.echartStaticsSaleOrder.sort((a,b)=>a.dictSort-b.dictSort).forEach((dict) => {
              saleOrder.push(res.data[dict.dictValue])
            })
            this.dictObj.echartStaticsOther.sort((a,b)=>a.dictSort-b.dictSort).forEach((dict) => {
              otherOrder.push(res.data[dict.dictValue])
            })

            this.$set(this.echartsData, 'saleOrder', saleOrder)
            this.$set(this.echartsData, 'otherOrder', otherOrder)
            console.log(this.echartsData);
          }
          resolve(res)
        })
          .catch(error => {
            console.log(error);
            reject(error)
            this.$message({
              type: 'error',
              message: '请求异常'
            })
          })
      })
    },
    getLeftData(params) {
      return new Promise((resolve, reject) => {
        this.data = [] // 清空表格数据
        getLeftData(params)
          .then(res => {
            this.orderData = res.data
            this.Leftloading = false
            resolve(res)
          })
          .catch(error => {
            reject(error)
            this.$message({
              type: 'error',
              message: '请求异常'
            })
          })
      })
    },
  }
}
</script>
